import './SearchDescription.svelte.css';
/* src/components/searchDescription/SearchDescription.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	destroy_each,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	src_url_equal,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[6] = list[i];
	return child_ctx;
}

// (15:2) {:else}
function create_else_block(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*h1*/ ctx[0])) attr(img, "src", img_src_value);
			attr(img, "alt", /*title*/ ctx[1]);
			attr(img, "width", "565");
			attr(img, "height", "80");
			attr(img, "loading", "eager");
			attr(img, "class", "svelte-lj16u7");
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*h1*/ 1 && !src_url_equal(img.src, img_src_value = /*h1*/ ctx[0])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 2) {
				attr(img, "alt", /*title*/ ctx[1]);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (13:2) {#if '' === h1}
function create_if_block(ctx) {
	let span;
	let t;

	return {
		c() {
			span = element("span");
			t = text(/*title*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*title*/ 2) set_data(t, /*title*/ ctx[1]);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (21:2) {#each texts as text}
function create_each_block(ctx) {
	let p;
	let t_value = /*text*/ ctx[6] + "";
	let t;

	return {
		c() {
			p = element("p");
			t = text(t_value);
			attr(p, "class", "svelte-lj16u7");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		p(ctx, dirty) {
			if (dirty & /*texts*/ 4 && t_value !== (t_value = /*text*/ ctx[6] + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let div1;
	let h1_1;
	let t0;
	let div0;
	let t1;
	let img;
	let img_src_value;

	function select_block_type(ctx, dirty) {
		if ('' === /*h1*/ ctx[0]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);
	let each_value = /*texts*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div1 = element("div");
			h1_1 = element("h1");
			if_block.c();
			t0 = space();
			div0 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t1 = space();
			img = element("img");
			attr(h1_1, "class", "stone-name svelte-lj16u7");
			attr(div0, "class", "stone-read svelte-lj16u7");
			attr(img, "class", "stone-visual svelte-lj16u7");
			if (!src_url_equal(img.src, img_src_value = /*eyecatch*/ ctx[3])) attr(img, "src", img_src_value);
			attr(img, "alt", /*title*/ ctx[1]);
			attr(img, "width", "145");
			attr(img, "height", "145");
			attr(img, "loading", "eager");
			attr(div1, "class", "stone-head svelte-lj16u7");
			set_style(div1, "background-image", "url(" + /*urlH1Img*/ ctx[4] + ")");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, h1_1);
			if_block.m(h1_1, null);
			append(div1, t0);
			append(div1, div0);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div0, null);
			}

			append(div1, t1);
			append(div1, img);
		},
		p(ctx, [dirty]) {
			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(h1_1, null);
				}
			}

			if (dirty & /*texts*/ 4) {
				each_value = /*texts*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div0, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*eyecatch*/ 8 && !src_url_equal(img.src, img_src_value = /*eyecatch*/ ctx[3])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*title*/ 2) {
				attr(img, "alt", /*title*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			if_block.d();
			destroy_each(each_blocks, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { h1 } = $$props;
	let { title } = $$props;
	let { texts } = $$props;
	let { eyecatch } = $$props;
	let { urlimg } = $$props;
	const urlH1Img = urlimg + '/common/bg_stoneSearch_01.gif';

	$$self.$$set = $$props => {
		if ('h1' in $$props) $$invalidate(0, h1 = $$props.h1);
		if ('title' in $$props) $$invalidate(1, title = $$props.title);
		if ('texts' in $$props) $$invalidate(2, texts = $$props.texts);
		if ('eyecatch' in $$props) $$invalidate(3, eyecatch = $$props.eyecatch);
		if ('urlimg' in $$props) $$invalidate(5, urlimg = $$props.urlimg);
	};

	return [h1, title, texts, eyecatch, urlH1Img, urlimg];
}

class SearchDescription extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			h1: 0,
			title: 1,
			texts: 2,
			eyecatch: 3,
			urlimg: 5
		});
	}
}

export default SearchDescription;